import { __assign, __read } from "tslib";
var documentDatesObject = {
    'activity.timestamp': null,
    'recentActivities.timestamp': null,
    lastAccessedTime: null,
    lastActionTime: null,
    lastModifiedTime: null,
    lastSharedTime: null,
    savedForLaterDateTime: null,
    createdDate: null,
};
/**
 * Converts a Folders card back to Document type. Additional logic to convert timestamp strings to Date object is needed
 * because Folders serialize Document objects prior to persisting them.
 * @param card Folders card
 * @returns Document object
 */
export function convertCardToDocument(card) {
    var document = __assign(__assign({}, card), { id: card.uniqueId, title: card.name });
    var processDocumentProp = function (obj, propName) {
        if (propName.indexOf('.') === -1) {
            if (!obj[propName]) {
                obj[propName] = undefined;
            }
            else if (typeof obj[propName] === 'string') {
                obj[propName] = new Date(obj[propName]);
            }
        }
        else {
            var _a = __read(propName.split('.')), firstProp = _a[0], restProps_1 = _a.slice(1);
            if (obj[firstProp]) {
                if (Array.isArray(obj[firstProp])) {
                    obj[firstProp].forEach(function (item) {
                        if (item) {
                            processDocumentProp(item, restProps_1.join('.'));
                        }
                    });
                }
                else {
                    processDocumentProp(obj[firstProp], restProps_1.join('.'));
                }
            }
        }
    };
    Object.keys(documentDatesObject).forEach(function (key) {
        processDocumentProp(document, key);
    });
    // Delete the following properties because they are reserved names for MFS cards
    delete document.uniqueId;
    delete document.name;
    delete document.type;
    return document;
}
//# sourceMappingURL=convertCardToDocument.js.map